import type { TranslatedString } from "../types"

/**
 * Irish translations for resource type display labels, keyed by the English label the cards render
 * (e.g. the string passed to `<TypeLabel label="Book" />`). Rendered Irish-first like the read-more
 * link: `Leabhar · Book`. A missing key degrades gracefully to English-only.
 *
 * Most terms verified against focloir.ie / tearma.ie (New English-Irish Dictionary + National
 * Terminology Database). Two remain coined compounds not found as dictionary headwords, kept as
 * best-guess pending a fluent-speaker check: Leabhar Cuairteoirí (guestbook — "visitors' book"),
 * Imeacht Féilire (calendar event — imeacht + féilire).
 */
export const RESOURCE_TYPE_LABEL_TRANSLATIONS: Record<string, string> = {
  Album: "Albam",
  App: "Aip",
  Audiobook: "Closleabhar",
  "Board Game": "Cluiche Cláir",
  Book: "Leabhar",
  "Calendar event": "Imeacht Féilire",
  Comic: "Greannán",
  Community: "Pobal",
  Course: "Cúrsa",
  Dictionary: "Foclóir",
  Documentary: "Clár Faisnéise",
  Event: "Imeacht",
  Flashcards: "Luaschártaí",
  Game: "Cluiche",
  Guestbook: "Leabhar Cuairteoirí",
  Interview: "Agallamh",
  "Mini Game": "Mionchluiche",
  Movie: "Scannán",
  "Music Video": "Físeán Ceoil",
  News: "Nuacht",
  Podcast: "Podchraoladh",
  Publication: "Foilseachán",
  Radio: "Raidió",
  Song: "Amhrán",
  "TV Show": "Clár Teilifíse",
  Teacher: "Múinteoir",
  Tool: "Uirlis",
  "Video Game": "Físchluiche",
  Website: "Suíomh Gréasáin",
  "YouTube Channel": "Cainéal YouTube",
}

/**
 * Bilingual label for a resource type display string. `translation` is empty when we have no Irish
 * for that label yet, so callers can fall back to English-only.
 */
export const getTypeLabelTranslation = (label: string): TranslatedString => ({
  text: label,
  translation: RESOURCE_TYPE_LABEL_TRANSLATIONS[label] ?? "",
})
